import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "ppm__card" }
const _hoisted_2 = { class: "ppm__identity" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "bi bi-person-fill",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "ppm__name" }
const _hoisted_6 = { class: "ppm__handle" }
const _hoisted_7 = { class: "ppm__status" }
const _hoisted_8 = { class: "ppm__streak" }
const _hoisted_9 = { class: "ppm__stats" }
const _hoisted_10 = { class: "ppm__actions" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 3,
  class: "ppm__hint"
}
const _hoisted_15 = ["disabled"]

import { computed } from "vue";
import { resolveAvatarSrc } from "@/constants/avatars";
import type { PublicProfile } from "@/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'PublicProfileModal',
  props: {
    profile: {},
    busy: { type: Boolean }
  },
  emits: ["close", "request", "accept", "decline", "invite"],
  setup(__props: any) {

const props = __props;



function fa(value: number | string): string {
  return String(value).replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[Number(d)]);
}

const avatarSrc = computed(() => resolveAvatarSrc(props.profile?.user.avatar_url));
const displayName = computed(
  () => props.profile?.user.full_name?.trim() || props.profile?.user.username || ""
);

const statusLabel = computed(() => {
  switch (props.profile?.friendship_status) {
    case "friends":
      return "دوست شما";
    case "incoming":
      return "درخواست دوستی برای شما فرستاده";
    case "outgoing":
      return "در انتظار پذیرش";
    case "self":
      return "پروفایل شما";
    default:
      return "هنوز دوست نیستید — استریک را ببینید و درخواست بفرستید";
  }
});

return (_ctx: any,_cache: any) => {
  return (__props.profile)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "ppm",
        role: "dialog",
        "aria-modal": "true",
        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            type: "button",
            class: "ppm__close",
            "aria-label": "بستن",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, " × "),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["ppm__avatar", { 'ppm__avatar--img': !!avatarSrc.value }])
            }, [
              (avatarSrc.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: avatarSrc.value,
                    alt: ""
                  }, null, 8, _hoisted_3))
                : (_openBlock(), _createElementBlock("i", _hoisted_4))
            ], 2),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(displayName.value), 1),
              _createElementVNode("p", _hoisted_6, "@" + _toDisplayString(__props.profile.user.username), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(statusLabel.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "ppm__streak-title" }, "پیشرفت استریک", -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, _toDisplayString(fa(__props.profile.streak.current_streak)), 1),
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "استریک فعلی", -1))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, _toDisplayString(fa(__props.profile.streak.longest_streak)), 1),
                _cache[7] || (_cache[7] = _createElementVNode("span", null, "بلندترین", -1))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, _toDisplayString(fa(__props.profile.streak.today.sessions_completed)) + "/" + _toDisplayString(fa(__props.profile.streak.daily_goal)), 1),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "هدف امروز", -1))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, _toDisplayString(fa(__props.profile.streak.today.xp_earned)), 1),
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "امتیاز امروز", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (__props.profile.friendship_status === 'none')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "ppm__primary",
                  disabled: __props.busy,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('request', __props.profile.user.username)))
                }, " ارسال درخواست دوستی ", 8, _hoisted_11))
              : (__props.profile.friendship_status === 'incoming' && __props.profile.incoming_request_id)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "ppm__primary",
                    disabled: __props.busy,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('accept', __props.profile.incoming_request_id)))
                  }, " پذیرش دوستی ", 8, _hoisted_12))
                : _createCommentVNode("", true),
            (__props.profile.friendship_status === 'incoming' && __props.profile.incoming_request_id)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  class: "ppm__ghost",
                  disabled: __props.busy,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('decline', __props.profile.incoming_request_id)))
                }, " رد کردن ", 8, _hoisted_13))
              : (__props.profile.friendship_status === 'outgoing')
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, " درخواست دوستی ارسال شده و در انتظار پاسخ است. "))
                : (__props.profile.friendship_status === 'friends')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 4,
                      type: "button",
                      class: "ppm__primary",
                      disabled: __props.busy,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('invite', __props.profile.user.username)))
                    }, " دعوت به اسپیکینگ ", 8, _hoisted_15))
                  : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})